import { setPlatformDep } from 'common/helpers/platformDeps';
import '@lib/toastr/toastr.css';

if (typeof window != 'undefined') {
	setPlatformDep('Toast', require('@lib/toastr/toastr.js'))
}

